import React, { Component } from 'react';
import LibraryList from '../LibraryList';
import NavigationTabs from '../nav/NavigationTabs'
import { COLORS } from '../../styles/colors';
import { AUTOMATION_LIBRARY_MESSAGE } from '../../static-content';
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }
  componentDidMount() {
    const { user, fetchList, fetchFormFilterData } = this.props;
    fetchList(user.type).then((res) => {
      this.setState({ dataLoaded: true, automations: res });
    });
  }

  render() {
    const { user, deleteAutomation, resetAutomations } = this.props;
    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="Automated Messages"
          description={AUTOMATION_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/automationMessages" />
        {this.state.dataLoaded &&
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
            <LibraryList
              items={Object.values(this.state.automations)}
              categoryField="catId"
              itemType="automation"
              user={user}
              deleteAutomation={deleteAutomation}
            />
          </div>}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/automations/List.js